import EventDispatcher from "../../../../lib/html5-software-library/src/ranj/util/EventDispatcher";
import AbstractContextObject from "../../app/core/AbstractContextObject";
import AbstractMediator from "../../app/ui/AbstractMediator";

export default class AbstractView extends EventDispatcher  {

    constructor(target) {
        super();
        this._target = target;
        //workaround for the issue that movieclip's children are not populated instantly (mcs in asset js contain '.wait(1)' for some reason)
        if (this._target.gotoAndStop != null) this._target.gotoAndStop(0);
    }

    destroy() {
        //Destroy all buttons that were created using createButton.
        if (this._buttons) {
            for (var i = 0; i < this._buttons.length; i++) {
                this._buttons[i].destroy();
            }
        }
        this.killDelayedCalls();
        this.removeAllEventListeners();
    }
}

//MIX-INS:

AbstractView.prototype.createButton = AbstractMediator.prototype.createButton;
AbstractView.prototype._decorateButton = AbstractMediator.prototype._decorateButton;
AbstractView.prototype.centerVertically = AbstractMediator.prototype.centerVertically;
AbstractView.prototype.applyText = AbstractMediator.prototype.applyText;

AbstractView.prototype.getText = AbstractContextObject.prototype.getText;
AbstractView.prototype._removeZeroWidthSpacesFromPlaceholders = AbstractContextObject.prototype._removeZeroWidthSpacesFromPlaceholders; 

AbstractView.prototype.callDelayed = AbstractContextObject.prototype.callDelayed;
AbstractView.prototype.killDelayedCall = AbstractContextObject.prototype.killDelayedCall;
AbstractView.prototype.killDelayedCalls = AbstractContextObject.prototype.killDelayedCalls;
AbstractView.prototype._unregisterDelayedCall = AbstractContextObject.prototype._unregisterDelayedCall;